import { MFAMethodsEnum } from '@fry-it/risr-core';


export const READABLE_MFA_METHODS = {
  [MFAMethodsEnum.EMAIL_OTP]: $localize`Email`,
  [MFAMethodsEnum.TOTP]: $localize`Authenticator`
};


export interface MFA {
  id: string;                // Unique ID for the MFA
  type: MFAMethodsEnum;      // Type of MFA
  createdAt: string;         // Creation timestamp
}
